export default __webpack_public_path__ + "static/media/icon-video.e0b595ff.svg";